import React from 'react';
import { Link } from 'react-router-dom';
import { Skeleton } from '../../../shared/components/Skeleton';
import { useCandidaturasDoCandidato, useEtapas } from '../hooks';
import { CandidaturaStatusBadge } from './RecrutamentoBadges';
import { formatClienteLabel, formatDateBR } from './format';
import { cargoDaVaga } from './VagaVinculadaCampos';

/**
 * Candidaturas do candidato: para qual vaga (ID), qual cliente, em que
 * etapa está e o status — a identificação que o RH procura ao abrir o
 * cadastro.
 */
export function CandidaturasDoCandidato({ candidateId }: { candidateId: string }) {
  const { data, isLoading, isError } = useCandidaturasDoCandidato(candidateId);
  const { data: etapas } = useEtapas();
  const labels = new Map((etapas ?? []).map((etapa) => [etapa.key, etapa.label]));

  return (
    <section>
      <h3 className="mb-2 text-sm font-medium text-gray-700">Candidaturas</h3>
      {isLoading ? (
        <Skeleton className="h-16 w-full" />
      ) : isError ? (
        <p className="text-sm text-red-600">Não foi possível carregar as candidaturas.</p>
      ) : !data || data.length === 0 ? (
        <p className="text-sm text-gray-500">Nenhuma candidatura registrada.</p>
      ) : (
        <ul className="divide-y divide-gray-100 rounded-lg border border-gray-200">
          {data.map((candidatura) => {
            const vaga = candidatura.jobOpening;
            const requisicao = vaga?.requisition;
            return (
              <li key={candidatura.id} className="flex flex-wrap items-start justify-between gap-2 p-3">
                <div className="min-w-0">
                  <p className="text-sm font-medium text-gray-900">
                    {requisicao?.code ?? '—'} — {vaga ? cargoDaVaga(vaga) || 'Vaga sem título' : '—'}
                  </p>
                  <p className="text-xs text-gray-600">
                    Cliente: {formatClienteLabel(requisicao?.client)}
                  </p>
                  <p className="mt-0.5 text-xs text-gray-500">
                    {labels.get(candidatura.currentStageKey) ?? candidatura.currentStageKey}
                    {` · inscrito em ${formatDateBR(candidatura.createdAt)}`}
                    {` · protocolo ${candidatura.protocol}`}
                  </p>
                </div>
                <div className="flex flex-col items-end gap-1">
                  <CandidaturaStatusBadge status={candidatura.status} />
                  <Link
                    to={`/recrutamento/processo-seletivo/${candidatura.jobOpeningId}`}
                    className="text-xs text-blue-600 hover:underline"
                  >
                    Ver processo seletivo
                  </Link>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
